//
// DeleteAccountPanel
//
// Use in a popover for deleting an account.

import { observer } from 'mobx-react-lite'
import { useState } from 'react'
import { useStore } from '../stores'

import { HView, VView } from '../appview'
import { Header, Menu, MenuItem, Text, Toggle } from '../components'

export const DeleteAccountPanel = observer(function DeleteAccountPanel({
    onConfirm,
    onCancel,
}) {
    const { app } = useStore()

    const [confirm, setConfirm] = useState(false)

    const _onConfirm = () => {
        onConfirm && onConfirm(confirm)
    }
    const _onCancel = () => {
        onCancel && onCancel()
    }

    return (
        <VView className="actions-panel change-password-panel">
            <div className="inspector cc-danger">
                <Header>{app.text('Delete account')}</Header>
                <VView
                    style={{
                        marginLeft: 5,
                        marginRight: 5,
                        marginBottom: 5,
                    }}
                >
                    <HView vcenter>
                        <Toggle onChange={value => setConfirm(value)} value={confirm} />
                        <Text>{app.text('Confirm account deletion')}</Text>
                    </HView>
                    <Text>
                        {app.text(
                            'When you delete your account, you will be removed from all projects you are participating in. You can NOT recover the account, once deleted.'
                        )}
                    </Text>
                </VView>
            </div>
            <Menu>
                <MenuItem
                    className="cc-danger"
                    disabled={!confirm}
                    onClick={_onConfirm}
                >
                    {app.text('Permanently delete account')}
                </MenuItem>
                <MenuItem onClick={_onCancel}>{app.text('Cancel')}</MenuItem>
            </Menu>
        </VView>
    )
})
